import { render, staticRenderFns } from "./reports-list.vue?vue&type=template&id=a0786d06&scoped=true"
import script from "./reports-list.vue?vue&type=script&lang=js"
export * from "./reports-list.vue?vue&type=script&lang=js"
import style0 from "./reports-list.vue?vue&type=style&index=0&id=a0786d06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0786d06",
  null
  
)

export default component.exports